import { Translation } from '../types';

export default {
  // App
  appTitle: "OK Money - 人生規劃模擬器",
  
  // Navigation
  navigation: {
    home: "首頁",
    lifePlan: "人生規劃",
    riskSimulation: "風險模擬",
    contact: "聯絡我們",
    openMenu: "開啟選單",
    lifePlanDescription: "建立人生規劃，設計您的未來生活",
    riskSimulationDescription: "執行風險模擬，評估投資風險",
  },

  // Home
  home: {
    hero: {
      title: "透過模擬實現真實生活規劃",
      subtitle: "透過考慮不確定性的模擬來優化您的人生規劃",
      download: "下載",
      docs: "文件"
    },
    features: {
      codeCompletion: {
        title: "即時模擬",
        description: "即時模擬市場波動，提供最優資金計劃"
      },
      codebase: {
        title: "AI分析",
        description: "使用歷史數據和AI分析您的投資組合，並提出改進建議"
      },
      naturalLanguage: {
        title: "豐富生活的投資",
        description: "透過投資增加資產，同時確保日常生活所需資金的安全"
      }
    },
  },

  // 会社情報と利用規約
  company: {
    title: "公司資訊",
    basicInfo: "基本資訊",
    operatorName: "營運公司名稱",
    startDate: "設立日期",
    startDateValue: "2025年4月28日",
    location: "所在地",
    locationValue: "神奈川縣橫濱市",
    contact: "聯絡我們",
    contactForm: "聯絡表單",
    businessDescription: "事業內容",
    businessDescriptionContent: "提供人生規劃模擬服務",
    developerProfile: "開發者簡介",
    developerProfileContent: "由SIer工程師個人開發。隨著孩子的誕生，致力於開發能幫助人們規劃未來、充分享受當下的服務。",
    privacyPolicy: "隱私權政策",
    privacyPolicyLink: "查看完整隱私權政策",
    termsOfService: "服務條款",
    termsOfServiceContent: "本公司將客戶個人資訊的保護視為最重要事項。",
    contentEnd: "如有任何疑問，請聯絡我們。"
  },
  terms: {
    title: "服務條款",
    termsOfService: "服務條款",
    privacyPolicy: "隱私權政策",
    article1: {
      title: "第1條（適用範圍）",
      content: "本條款規定OKMoney（以下簡稱「本公司」）所提供服務（以下簡稱「本服務」）的使用條件。"
    },
    article2: {
      title: "第2條（使用註冊）",
      content1: "1. 使用本服務時，必須同意本條款並依本公司規定的方式進行使用註冊。",
      content2: "2. 本公司對於註冊申請者，在以下情況下可能拒絕註冊：",
      listItem1: "曾違反本條款者",
      listItem2: "其他本公司認為不適當的情況"
    },
    article3: {
      title: "第3條（禁止事項）",
      content: "用戶不得進行以下行為：",
      listItem1: "違反法令或公序良俗的行為",
      listItem2: "與犯罪行為相關的行為",
      listItem3: "可能妨礙本公司服務營運的行為",
      listItem4: "對其他用戶造成困擾的行為",
      listItem5: "其他本公司認為不適當的行為"
    },
    article4: {
      title: "第4條（服務停止等）",
      content: "本公司認為有以下情況時，可不事先通知用戶而停止或中斷本服務的全部或部分：",
      listItem1: "進行本服務相關電腦系統的維護檢查或更新時",
      listItem2: "因地震、雷擊、火災、停電或天災等不可抗力因素，導致服務提供困難時",
      listItem3: "其他本公司認為服務提供困難的情況"
    },
    article5: {
      title: "第5條（免責事項）",
      content: "本公司對於本服務中，用戶與其他用戶或第三方之間發生的交易、聯絡或糾紛等，不負任何責任。"
    },
    article6: {
      title: "第6條（服務內容變更等）",
      content: "本公司可不通知用戶而變更服務內容或中止服務提供，對此造成的用戶損害不負任何責任。"
    },
    article7: {
      title: "第7條（條款變更）",
      content: "本公司認為必要時，可不通知用戶而隨時變更本條款。"
    },
    article8: {
      title: "第8條（通知或聯絡）",
      content: "用戶與本公司之間的通知或聯絡，應依本公司規定的方式進行。"
    },
    article9: {
      title: "第9條（禁止轉讓權利義務）",
      content: "用戶未經本公司書面同意，不得將使用契約上的地位或本條款所定權利義務轉讓給第三方或作為擔保。"
    },
    article10: {
      title: "第10條（準據法・管轄法院）",
      content1: "1. 本條款的解釋適用日本法律。",
      content2: "2. 關於本服務發生糾紛時，以本公司總公司所在地的法院為專屬合意管轄法院。"
    },
    privacy: {
      article1: {
        title: "1. 關於個人資訊的收集",
        content: "本網站提供服務時，可能收集以下個人資訊：",
        listItem1: "姓名",
        listItem2: "電子郵件地址",
        listItem3: "地址",
        listItem4: "電話號碼",
        listItem5: "其他服務提供所需的資訊"
      },
      article2: {
        title: "2. 個人資訊的使用目的",
        content: "收集的個人資訊將用於以下目的：",
        listItem1: "服務的提供與營運",
        listItem2: "處理客戶詢問",
        listItem3: "服務的改善與開發",
        listItem4: "重要通知的發送"
      },
      article3: {
        title: "3. 個人資訊的管理",
        content: "本網站實施適當的安全措施，防止個人資訊的洩漏、遺失或毀損。"
      },
      article4: {
        title: "4. 個人資訊的第三方提供",
        content: "本網站除以下情況外，不會向第三方提供個人資訊：",
        listItem1: "獲得本人同意時",
        listItem2: "基於法令要求時",
        listItem3: "為保護人的生命、身體或財產所必要時"
      },
      article5: {
        title: "5. 聯絡方式",
        content: "關於隱私權政策的詢問，請透過聯絡表單與我們聯繫。"
      },
      article6: {
        title: "6. 隱私權政策的變更",
        content: "本網站可能視需要變更本隱私權政策。變更時將在本網站公告。"
      }
    }
  },

  // 共通
  common: {
    years: "年",
    perYear: "/年",
    perMonth: "/月",
    age: "年齡",
    yes: "是",
    no: "否",
    none: "無",
    notEntered: "未輸入",
    add: "新增",
    delete: "刪除",
    save: "儲存",
    cancel: "取消",
    reset: "重設",
    month: "月",
    select: "選擇",
    clearSelection: "清除選擇",
    dateTime: "日期時間",
    actions: "操作",
    currencies: {
      jpy: "日圓",
      usd: "美元",
      eur: "歐元",
      gbp: "英鎊",
      aud: "澳元",
      cad: "加元",
      chf: "瑞士法郎",
      cny: "人民幣",
      hkd: "港幣",
      sgd: "新加坡元"
    },
    currency: "貨幣",
    currencyHelp: "選擇貨幣。模擬將以所選貨幣進行。",
    statistics: {
      title: "統計",
      mean: "平均",
      median: "中位數",
      min: "最小值",
      max: "最大值",
      mode: "眾數",
      totalInvestment: "總投資額",
      assetDistribution: "資產分配",
      targetAchieveRate: "目標達成率",
      probability: "機率",
      medianFinalAsset: "中位數最終資產",
      finalAsset: "最終資產",
    }
  },

  // リスクシミュレーション
  riskSimulation: {
    title: "風險模擬",
    simulationSettings: "模擬設定",
    initialInvestment: "初始投資額",
    investmentAmount: "投資金額",
    investmentPeriod: "投資期間",
    annualReturnRate: "年化報酬率",
    monthlyInvestment: "月投資額",
    volatility: "波動率",
    targetAmount: "目標金額",
    runSimulation: "執行模擬",
    running: "執行中",
    simulationInstruction: "請先執行模擬。",
    noSimulationRun: "尚未執行模擬",
    simulationResults: "模擬結果",
    currentResults: "目前結果",
    savedResults: "已儲存結果",
    compare: "比較",
    resultTitle: "風險模擬結果",
    simulationConditions: "模擬條件",
    saveSimulationResult: "儲存模擬結果",
    saveSimulationDescription: "請輸入模擬結果的名稱。",
    simulationName: "模擬名稱",
    simulationNamePlaceholder: "輸入模擬結果名稱",
    saveSimulation: "儲存模擬",
    noSavedSimulations: "無已儲存模擬",
    noSavedSimulationsDescription: "找不到已儲存的模擬。請先執行模擬。",
    createNewSimulation: "建立新模擬",
    selectSimulationsToCompare: "選擇要比較的模擬",
    noSelectedSimulations: "未選擇模擬",
    selectTwoOrMoreSimulations: "請選擇兩個以上的模擬。",
    comparisonResults: "比較結果",
    finalAssetComparison: "最終資產比較",
    finalAssetComparisonDescription: "模擬最終資產的比較",
    successRateComparison: "成功率比較",
    successRateComparisonDescription: "模擬成功率的比較",
    simulationParameters: "模擬參數",
    simulationParametersDescription: "模擬參數的比較",
    period: "期間",
    successRate: "成功率",
    backToSimulation: "返回模擬",
  },

  // ライフプラン
  lifePlan: {
    title: "人生規劃",
    resultTitle: "人生規劃模擬結果",
    steps: {
      basicInfo: "基本資訊",
      incomeExpense: "收支",
      assetsLiabilities: "資產負債",
      lifeGoals: "人生事件",
      simulationSettings: "模擬設定",
      confirmation: "確認",
    },
    navigation: {
      prev: "上一步",
      next: "下一步",
      startSimulation: "開始模擬",
      confirmStart: "是否開始模擬？",
      confirmStartTitle: "確認開始模擬",
      cancel: "取消",
    },
    basicInfo: {
      title: "基本資訊",
      name: "姓名",
      namePlaceholder: "請輸入姓名",
      age: "年齡",
      gender: {
        title: "性別",
        male: "男性",
        female: "女性",
        other: "其他",
      },
      familyStructure: {
        title: "家庭結構",
        hasSpouse: "有配偶",
        spouseAge: "配偶年齡",
        children: "子女",
        help: "請輸入家庭結構",
        childrenHelp: "請輸入子女年齡",
        addChild: "新增子女",
        removeChild: "刪除子女",
        noChildren: "無子女",
      },
      spouse: "配偶",
      children: "子女"
    },
    incomeExpense: {
      title: "收支",
      income: {
        title: "收入",
        annualIncome: "年薪（萬元）",
        salaryIncreaseRate: "加薪率（%）",
        annualBonus: "年終獎金（萬元）",
      },
      expense: {
        title: "支出",
        help: "請輸入月支出",
        housingCost: "居住費用（萬元/月）",
        housingCostHelp: "請輸入每月房租或貸款還款金額",
        utilities: "水電費（萬元/月）",
        food: "餐費（萬元/月）",
        communication: "通訊費（萬元/月）",
        transportation: "交通費（萬元/月）",
        entertainment: "娛樂費（萬元/月）",
        investment: "投資（萬元/月）",
        stocks: "股票投資（萬元/月）",
        bonds: "債券投資（萬元/月）",
        mutualFunds: "基金投資（萬元/月）",
        insurance: "保險費（萬元/月）",
        other: "其他（萬元/月）"
      },
      annualIncome: "年薪",
      salaryIncreaseRate: "加薪率",
      annualBonus: "年終獎金",
      housingCost: "居住費用",
      utilities: "水電費",
      food: "餐費",
      communication: "通訊費",
      transportation: "交通費",
      entertainment: "娛樂費",
      other: "其他"
    },
    assetsLiabilities: {
      title: "資產負債",
      assets: {
        title: "資產",
        savings: "存款",
        stocks: "股票",
        bonds: "債券",
        mutualFunds: "基金",
        insurance: "保險",
        other: "其他",
        amount: "金額（萬元）",
        return: "預期報酬率（%）",
        volatility: "波動率（%）",
        investmentAssets: "投資資產",
      },
      liabilities: {
        title: "負債",
        housingLoan: "房屋貸款",
        carLoan: "汽車貸款",
        otherLoans: "其他貸款",
        addLoan: "新增貸款",
        removeLoan: "刪除貸款",
        name: "貸款名稱",
        amount: "貸款金額",
        period: "還款期限（年）",
        interestRate: "利率（%）",
        noLoans: "無貸款",
      },
      savings: "存款",
      stocks: "股票",
      bonds: "債券",
      mutualFunds: "基金",
      insurance: "保險",
      otherInvestments: "其他投資",
      housingLoanBalance: "房屋貸款餘額",
      housingLoanPeriod: "貸款期限",
      housingLoanInterest: "利率",
      noLoans: "無貸款",
      otherLoans: "其他貸款"
    },
    lifeGoals: {
      title: "人生事件",
      housingPurchase: "購屋",
      educationFunds: "教育基金",
      child: "子女",
      otherGoals: "其他目標",
      retirementAge: "退休年齡",
      retirementMonthlyExpense: "退休後月支出",
      notPlanned: "未規劃",
      housing: {
        title: "購屋",
        planned: "預計購屋",
        year: "預計購屋年份",
        amount: "預計購屋金額（萬元）",
        purchaseAmount: "購屋金額（萬元）",
        purchaseYear: "購屋年份",
      },
      education: {
        title: "教育資金計劃",
        subtitle: "教育資金規劃",
        add: "添加教育資金",
        remove: "刪除教育資金",
        name: "教育資金名稱",
        namePlaceholder: "輸入教育資金名稱",
        childAge: "子女年齡",
        age: "所需年齡",
        amount: "所需金額",
        requiredAmount: "所需金額",
        noData: "未添加教育資金",
      },
      other: {
        title: "其他目標",
        subtitle: "其他人生事件",
        add: "新增目標",
        remove: "刪除目標",
        name: "目標名稱",
        year: "目標年份",
        amount: "所需金額（百萬日圓）",
        noData: "暫無目標",
        namePlaceholder: "請輸入其他目標名稱",
        plannedAge: "計劃年齡",
        requiredAmount: "所需金額"
      },
      retirement: {
        title: "退休規劃",
        age: "預計退休年齡",
        monthlyExpense: "退休後月支出（萬元）",
      },
    },
    simulationSettings: {
      title: "模擬設定",
      inflationRate: "通貨膨脹率",
      investmentReturn: "投資回報率",
      simulationPeriod: "模擬期間",
      currency: "貨幣",
      currencyHelp: "選擇貨幣。模擬將以所選貨幣進行。",
      inflationRateHelp: "考慮未來通貨膨脹率的模擬。"
    },
    runningSimulation: "模擬執行中",
    result: {
      title: "人生規劃模擬結果",
      settings: "人生規劃設定",
      planSettings: "規劃設定",
      actions: {
        print: "列印",
        downloadCSV: "下載CSV",
        modifyConditions: "修改條件",
        backToInput: "返回輸入畫面",
      },
      tabs: {
        charts: "圖表",
        details: "詳細",
        analysis: "分析建議",
      },
      charts: {
        assetIncomeExpense: "資產收支變化",
        agePoint: "{age}歲時",
        spouse: "配偶：{age}歲",
        children: "子女",
        age: "{age}歲",
        assets: "資產",
        liabilities: "負債",
        netWorth: "淨資產",
        amount: "金額（萬元）",
        noData: "無資料",
        assetTrend: "資產變化",
        incomeExpenseTrend: "收支變化",
        income: "收入",
        expense: "支出",
        savings: "儲蓄",
      },
      details: {
        yearlyData: "年度資料詳細",
      },
      analysis: {
        risk: "風險分析",
        recommendations: "改善建議",
      },
      table: {
        search: "搜尋...",
        age: "年齡",
        familyAge: "家庭年齡",
        income: "收入",
        expense: "支出",
        savings: "儲蓄",
        assets: "資產餘額",
        lifeEvents: "人生事件",
        ageValue: "{age}歲",
        spouse: "配偶：{age}歲",
        children: "子女",
        amount: "萬元",
        noData: "無資料",
      },
      timeline: {
        age: "年齡",
        event: "事件",
        retirement: "退休",
        ageValue: "{age}歲",
        agePoint: "{age}歲時",
        spouse: "配偶：{age}歲",
        children: "子女",
        neededAmount: "需要金額：{amount}",
        assets: "資產：{amount}",
        education: "{childName}的{fundName}",
        child: "子女",
        educationFund: "教育基金"
      },
      summary: {
        title: "摘要",
        monthlyIncome: "月收入",
        monthlyExpense: "月支出",
        monthlyInvestment: "月投資額",
        monthlySavings: "月儲蓄額",
        totalAssets: "總資產",
        totalLiabilities: "總負債",
        netWorth: "淨資產",
        finalAssets: "最終資產",
        peakAssets: "資產高峰",
        retirementAssets: "退休時資產",
        savingsRate: "儲蓄率",
        savingsRateDesc: "收入中的儲蓄比例",
        retirementBalance: "退休後收支",
        balance: "收支",
        riskAssessment: "風險評估",
        riskLow: "低風險",
        riskMedium: "中風險",
        riskHigh: "高風險",
        negativeAssets: "未來將有資產為負的期間。",
        positiveAssets: "資產預計將持續維持正數。",
        needImprovement: "需要改善收支狀況。",
        unit: "萬元",
        atAge: "{age}歲時",
      },
      chart: {
        title: "資產變化預覽",
        noData: "請輸入資料",
        assets: "資產",
        income: "收入",
        expense: "支出",
      },
    },
    confirmation: {
      title: "確認"
    },
    validation: {
      error: "輸入內容有誤。"
    },
  },
  login: "登入",
  register: "註冊",
  loginDescription: "還沒有帳號？請註冊。",
  registerDescription: "建立帳號開始您的人生規劃模擬。",
  email: "電子郵箱",
  password: "密碼",
  passwordRequirements: "密碼必須至少8個字符，並包含字母和數字。",
  loggingIn: "登入中...",
  registering: "註冊中...",
  loginFailed: "登入失敗。",
  registrationSuccess: "註冊成功。",
  registrationFailed: "註冊失敗。",
  myPage: "我的帳戶",
  logout: "登出",
  userProfile: "用戶資料",
  userProfileDescription: "管理您的個人資料資訊",
  savedSimulations: "已儲存的模擬",
  savedSimulationsDescription: "您儲存的模擬結果列表",
  settings: "設定",
  accountSettings: "帳戶設定",
  accountSettingsDescription: "管理您的帳戶設定",
  changePassword: "修改密碼",
  changePasswordDescription: "更改您的密碼",
} as Translation; 